<split-steps *ngIf="isLoadingUnit == false && (unitState$ | async)?.type != 'loading' && !isUploadLoading" #steps
  (stepChange)="onActiveIndexChanged($event)" [activeIndex]="activeIndex">
  <split-step [passo]="0" class="mt-2">
    <form [formGroup]="form" (ngSubmit)="OnSubmit()">
      <div class="linha-button mb-4">
        <p-selectButton class="inativo" [options]="[
            { label: 'Matriz', value: true },
            { label: 'Filial', value: false }
          ]" optionLabel="label" optionValue="value" formControlName="main"
          (onChange)="resetFlagUsesHeadOfficeTaxData()"></p-selectButton>

        <div class="switch-box">
          <div class="switch-line">
            <p-inputSwitch formControlName="flagIssuesInvoice" (onChange)="onChangeSplitNF()"></p-inputSwitch>
            <span class="label-switch ml-2">Split e Nota Fiscal</span>
          </div>

          <div class="switch-line" *ngIf="!form.value.main && form.value.flagIssuesInvoice">
            <p-inputSwitch (onChange)="onChangeDadosFiscaisMatriz()"
              formControlName="flagUsesHeadOfficeTaxData"></p-inputSwitch>
            <span class="label-switch ml-2">Utilizar dados fiscais da matriz</span>
            <div class="info-container">
              <img class="info" src="assets\cadastrar-unidade\information-icon.svg" alt="informativo"
                [pTooltip]="tooltipContent" tooltipPosition="bottom" />
              <ng-template #tooltipContent>
                Caso ativar esse campo, as receitas <br />
                vinculadas a Filial, serão emitidas <br />
                notas fiscais diretamente pela matriz <br />
              </ng-template>
            </div>
          </div>
        </div>


      </div>

      <div class="mb-4"
        *ngIf="form.value.flagIssuesInvoice && form.value.flagUsesHeadOfficeTaxData && !form.value.main ">
        <span class="useMainTaxDataInfo">Os dados fiscais da sua matriz foram salvos em nosso sistema. </span> <br>
        <span class="useMainTaxDataInfo">Por esse motivo preencha apenas os campos individuais necessários. </span>
      </div>

      <div class="grid p-fluid" *ngIf="!form.value.flagIssuesInvoice">
        <div class="col-6 mb-3">
          <span class="p-float-label">
            <input pInputText id="nomeUnidade" formControlName="unitName" />
            <label htmlFor="nomeUnidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Nome da Unidade
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-inputMask [unmask]="true" [autoClear]="false" id="celular" mask="(99) 99999-9999"
              formControlName="contactNumber">
            </p-inputMask>
            <label htmlFor="celular" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Celular
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-5">
          <span class="p-float-label">
            <input pInputText id="emailUnidade" formControlName="contactEmail" />
            <label htmlFor="emailUnidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Email
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-5">
          <span class="p-float-label">
            <p-inputMask [unmask]="true" [autoClear]="false" id="cnpj" mask="99.999.999/9999-99"
              formControlName="registrationNumber">
            </p-inputMask>
            <label htmlFor="cnpj" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              CNPJ
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>
      </div>

      <div class="grid p-fluid" *ngIf="
          form.value.flagIssuesInvoice && !form.value.flagUsesHeadOfficeTaxData
        ">
        <div class="col-6 mb-3">
          <span class="p-float-label">
            <input pInputText id="nomeUnidade" formControlName="unitName" />
            <label htmlFor="nomeUnidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Nome da Unidade
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-inputMask [unmask]="true" [autoClear]="false" id="celular" mask="(99) 99999-9999"
              formControlName="contactNumber">
            </p-inputMask>
            <label htmlFor="celular" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Celular
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <input pInputText id="emailUnidade" formControlName="contactEmail" />
            <label htmlFor="emailUnidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Email
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-inputMask [unmask]="true" [autoClear]="false" id="cnpj" mask="99.999.999/9999-99"
              formControlName="registrationNumber">
            </p-inputMask>
            <label htmlFor="cnpj" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              CNPJ
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <ng-container formGroupName="taxInfo">
          <div class="col-6 mb-3">
            <span class="p-float-label">
              <input pInputText id="razaoSocial" formControlName="legalName" />
              <label htmlFor="razaoSocial" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Razão Social
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3">
            <span class="p-float-label">
              <input pInputText id="nomeFantasia" formControlName="tradeName" />
              <label htmlFor="nomeFantasia" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Nome Fantasia
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3">
            <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
              <img [pTooltip]="tooltipRegimeTributario" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                alt="alerta-campo-vazio" />
            </label>
            <span class="p-float-label -mt-3">
              <p-dropdown [options]="tiposRegimeTributario" [autoDisplayFirst]="false" optionLabel="name"
                optionValue="@id" inputId="regimeTributario" formControlName="taxRegime">
              </p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="regimeTributario">
                Regime Tributário
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                    alt="alerta-campo-vazio" /> -->
              </label>
            </span>
            <ng-template #tooltipRegimeTributario>
              <div class="flex align-items-start justify-content-center flex-column">
                É um sistema que estabelece a cobrança de impostos de cada CNPJ,
                informando qual modelo tributário sua contabilidade determinou (
                ex simples nacional )
              </div>
            </ng-template>
          </div>

          <div class="col-6 mb-3">
            <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
              <img [pTooltip]="tooltipRegimeEspecial" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                alt="alerta-campo-vazio" />
            </label>
            <span class="p-float-label -mt-3">
              <p-dropdown [filter]="true" filterBy="name" [options]="tiposRegimeEspecial" [autoDisplayFirst]="false"
                optionLabel="name" optionValue="@id" inputId="regimeEspecial" formControlName="specialRegime">
              </p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="regimeEspecial">
                Regime Especial
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                    alt="alerta-campo-vazio" /> -->
              </label>
            </span>
            <ng-template #tooltipRegimeEspecial>
              <div class="flex align-items-start justify-content-center flex-column">
                É um regime tributário especial, no qual a empresa possui
                benefícios tributários que incidem para redução do seu imposto.
              </div>
            </ng-template>
          </div>

          <!-- <div class="col-4 mb-3">
                        <span [pTooltip]="tooltipCRT" class="p-float-label">
                            <p-dropdown [options]="tiposTaxRegimeCode" [autoDisplayFirst]="false" optionLabel="name"
                                optionValue="@id" inputId="taxRegimeCode" formControlName="taxRegimeCode">
                            </p-dropdown>
                            <label class="text-xs pl-1 h-1rem flex align-items-center" for="taxRegimeCode">
                                CRT -->
          <!-- <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                    alt="alerta-campo-vazio" /> -->
          <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                    alt="alerta-campo-vazio" />
                            </label>
                        </span>
                        <ng-template #tooltipCRT>
                            <div class="flex align-items-start justify-content-center flex-column">
                                É um regime tributário especial, no qual a empresa possui benefícios tributários que incidem para redução do seu imposto.
                            </div>
                        </ng-template>
                    </div> -->

          <div class="col-4 mb-3">
            <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
              <img [pTooltip]="tooltipIE" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                alt="alerta-campo-vazio" />
            </label>

            <span class="p-float-label -mt-3">
              <input pKeyFilter="int" pInputText id="inscricaoEstadual" formControlName="stateRegistration" />
              <label htmlFor="inscricaoEstadual" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Inscrição Estadual
                <!-- <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                    alt="alerta-campo-vazio" /> -->
                <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                    alt="alerta-campo-vazio" /> -->
              </label>
            </span>

            <ng-template #tooltipIE>
              <div class="flex align-items-start justify-content-center flex-column">
                A Inscrição Estadual é o número de registro de uma empresa, no
                estado onde ela está estabelecida, para que o negócio possa
                produzir ou vender mercadorias no Brasil. Em geral, empresas
                médicas e salões de beleza são isentas ( confirmar com seu
                contador ). Em caso de serem isentas, não preencher.
              </div>
            </ng-template>
          </div>

          <div class="col-4 mb-3">
            <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
              <img [pTooltip]="tooltipIM" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                alt="alerta-campo-vazio" />
            </label>
            <span class="p-float-label -mt-3">
              <input pInputText pKeyFilter="int" id="inscricaoMunicipal" formControlName="municipalRegistration" />
              <label htmlFor="inscricaoMunicipal" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Inscrição Municipal
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

            <ng-template #tooltipIM>
              <div class="flex align-items-start justify-content-center flex-column">
                A Inscrição Municipal é o registro do CNPJ na Prefeitura onde o
                profissional ou a empresa irá atuar. Serve como uma
                identificação cadastral no município, ou seja, é o domicílio
                fiscal do seu negócio. Você pode solicitar seu contador ou
                verificar no seu cartão CNPJ.
              </div>
            </ng-template>
          </div>

          <div class="col-4 mb-3">
            <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
              <img [pTooltip]="tooltipISS" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                alt="alerta-campo-vazio" />
            </label>
            <span class="p-float-label -mt-3"
              [ngClass]="{ 'inativo' : form.value.taxInfo?.taxRegime != '/api/tax_regimes/1'}">
              <!-- <input pInputText id="aliquotaISS" formControlName="issRate" /> -->

              <p-inputNumber id="aliquotaISS" formControlName="issRate" [minFractionDigits]="1" mode="decimal"
                suffix=" %">
              </p-inputNumber>

              <label htmlFor="aliquotaISS" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Aliquota ISS Simples Nacional
                <!-- <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                                    alt="alerta-campo-vazio" /> -->
                <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                    alt="alerta-campo-vazio" /> -->
              </label>
            </span>

            <ng-template #tooltipISS>
              <div class="flex align-items-start justify-content-center flex-column">
                É a taxa do Simples Nacional na sua Cidade. Caso seu modelo não
                seja simples nacional, será calculado automaticamente.
              </div>
            </ng-template>
          </div>

          <div class="col-8 mb-3" [ngClass]="{ 'mb-5' : !form.value.main }">
            <label class="label-sticky text-xs pl-1 h-1rem flex align-items-center">
              <img [pTooltip]="tootipOccupationArea" class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                alt="alerta-campo-vazio" />
            </label>
            <!--
            <span class="p-float-label -mt-3">
              <input
                pKeyFilter="int"
                pInputText
                id="codigoServico"
                formControlName="serviceCode"
              />
              <label
                htmlFor="codigoServico"
                class="text-xs pl-1 h-1rem flex align-items-center"
                for="float-label"
              >
                Código de Serviço Padrão
                <img
                  class="pl-1"
                  src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                  alt="alerta-campo-vazio"
                />
              </label>
            </span>
            -->
            <span class="p-float-label -mt-3">
              <p-dropdown [filter]="true" filterBy="description" [options]="occupationAreaList"
                [autoDisplayFirst]="false" optionLabel="description" [formControl]="occupationAreaFormControl"
                optionValue="@id" inputId="">
              </p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="regimeEspecial">
                Área de ocupação
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                <!-- <img class="pl-1" src="assets\icons\akar-icons_info-fill.svg"
                                    alt="alerta-campo-vazio" /> -->
              </label>
            </span>
            <ng-template #tooltipCodigoServico>
              <div class="flex align-items-start justify-content-center flex-column">
                Trata-se de um código exigido por boa parte das prefeituras para
                emissão de nota fiscal. Ele é determinado pelo CNAE exercido na
                cidade. Sugerimos verificar com contabilidade ou pode verificar
                na última nota emitida.
              </div>
            </ng-template>
            <ng-template #tootipOccupationArea>
              <div class="flex align-items-start justify-content-center flex-column">
                Selecione a área de ocupação .
              </div>
            </ng-template>
          </div>
        </ng-container>
        <div class="col-4 mb-3" [ngClass]="{ 'mb-5' : !form.value.main }">
          <span class="p-float-label">
            <p-inputNumber formControlName="annual_revenue" id="annual_revenue" mode="currency" currency="BRL"
              locale="pt-BR" currencyDisplay="symbol"> </p-inputNumber>
            <label htmlFor="annual_revenue" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Receita Anual
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>


        <ng-container formGroupName="taxInfo" *ngIf="form.value.main">
          <div class="col-4 mb-5">
            <span class="p-float-label">
              <p-dropdown [filter]="true" [filterFields]="['name', 'code']" [options]="bankList"
                [autoDisplayFirst]="false" optionLabel="name" optionValue="@id" inputId="bank" formControlName="bank">
                <ng-template let-bank pTemplate="selectedItem">
                  {{ formatNumberBank(bank) }}
                </ng-template>
                <ng-template let-bank pTemplate="item">
                  {{ formatNumberBank(bank) }}
                </ng-template>
              </p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="bank">
                Banco
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-2 mb-5">
            <span class="p-float-label">
              <input pKeyFilter="int" maxlength="4" pInputText id="agencia" formControlName="bankBranch" />
              <label htmlFor="agencia" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Agencia
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-4 mb-5">
            <span class="p-float-label">
              <input pInputText maxlength="13" pKeyFilter="int" id="contaCorrente" formControlName="checkingAccount" />
              <label htmlFor="contaCorrente" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Conta Corrente
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>
          <div class="col-2 mb-5">
            <span class="p-float-label">
              <input pInputText pKeyFilter="int" maxlength="2" id="digit" formControlName="digit" />
              <!-- <p-inputMask id="conta-corrente" mask="9999-9999-99" formControlName="checkingAccount"> </p-inputMask> -->
              <label htmlFor="digit" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Digito
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

        </ng-container>
      </div>

      <div class="grid p-fluid" *ngIf="
          form.value.flagIssuesInvoice &&
          !form.value.main &&
          form.value.flagUsesHeadOfficeTaxData
        ">
        <div class="col-6 mb-3">
          <span class="p-float-label">
            <input pInputText id="nomeUnidade" formControlName="unitName" />
            <label htmlFor="nomeUnidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Nome da Unidade
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-inputMask [unmask]="true" [autoClear]="false" id="celular" mask="(99) 999999999"
              formControlName="contactNumber">
            </p-inputMask>
            <label htmlFor="celular" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Celular
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <input pInputText id="emailUnidade" formControlName="contactEmail" />
            <label htmlFor="emailUnidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              Email
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-6 mb-3">
          <span class="p-float-label">
            <p-inputMask [unmask]="true" [autoClear]="false" id="cnpj" mask="99.999.999/9999-99"
              formControlName="registrationNumber">
            </p-inputMask>
            <label htmlFor="cnpj" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
              CNPJ
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <div class="col-12 mb-3">
          <span class="p-float-label">
            <p-dropdown [filter]="true" filterBy="description" [options]="occupationAreaList"
              [autoDisplayFirst]="false" optionLabel="description" [formControl]="occupationAreaFormControl"
              optionValue="@id" inputId="occupationAreaFilial">
            </p-dropdown>
            <label class="text-xs pl-1 h-1rem flex align-items-center" for="occupationAreaFilial">
              Área de ocupação
              <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
            </label>
          </span>
        </div>

        <ng-container formGroupName="address">

          <div class="col-6 mb-3">
            <span class="p-float-label">
              <p-inputMask [unmask]="true" [autoClear]="false" #cep id="cep" mask="99 999-999"
                formControlName="postalCode" (onComplete)="autoCompleteAddress(cep.value!, null)">
              </p-inputMask>
              <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                CEP
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3">
            <span class="p-float-label">
              <input pInputText id="bairro" formControlName="district" />
              <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Bairro
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3">
            <span class="p-float-label">
              <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                (onChange)="loadCitiesByUF($event.value, true)" [filter]="true" filterBy="name" [options]="stateList"
                optionLabel="name" optionValue="uf" id="estado" formControlName="state"></p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Estado
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

          </div>
          <div class="col-6 mb-3">
            <div class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
              *ngIf="isLoadingCities">
              Aguarde...
            </div>
            <span class="p-float-label" *ngIf="!isLoadingCities && !errIbge">
              <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                [emptyMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome" [options]="citiesListPJ"
                id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                inputId="float-label"></p-dropdown>
              <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                Cidade
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

            <span class="p-float-label" *ngIf="errIbge">
              <input pInputText id="cidade" formControlName="city" />
              <label htmlFor="cidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Cidade
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

          </div>

          <div class="col-12 mb-3">
            <span class="p-float-label">
              <input formControlName="streetAddress" pInputText id="logradouro" />
              <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Logradouro
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-5">
            <span class="p-float-label">
              <p-inputNumber inputId="integeronly" id="numero" formControlName="number">
              </p-inputNumber>
              <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Número
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

          </div>

          <div class="col-6 mb-5">
            <span class="p-float-label">
              <input formControlName="address2" pInputText id="complemento" />
              <label htmlFor="complemento" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Complemento
              </label>
            </span>
          </div>

        </ng-container>
      </div>

    </form>
  </split-step>

  <split-step [passo]="1" aria-disabled="true" *ngIf="!form.value.flagUsesHeadOfficeTaxData">
    <form [formGroup]="form">
      <ng-container formGroupName="address">
        <div class="grid p-fluid mt-2">
          <div class="col-6 mb-3">
            <span class="p-float-label">
              <p-inputMask [unmask]="true" [autoClear]="false" #cep id="cep" mask="99 999-999"
                formControlName="postalCode" (onComplete)="autoCompleteAddress(cep.value!, null)">
              </p-inputMask>
              <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                CEP
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3">
            <span class="p-float-label">
              <input pInputText id="bairro" formControlName="district" />
              <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Bairro
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-3">
            <span class="p-float-label">
              <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                (onChange)="loadCitiesByUF($event.value, true)" [filter]="true" filterBy="name" [options]="stateList"
                optionLabel="name" optionValue="uf" id="estado" formControlName="state"></p-dropdown>
              <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Estado
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

          </div>
          <div class="col-6 mb-3">
            <div class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
              *ngIf="isLoadingCities">
              Aguarde...
            </div>
            <span class="p-float-label" *ngIf="!isLoadingCities && !errIbge">
              <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                [emptyMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome" [options]="citiesListPJ"
                id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                inputId="float-label"></p-dropdown>
              <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                Cidade
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

            <span class="p-float-label" *ngIf="errIbge">
              <input pInputText id="cidade" formControlName="city" />
              <label htmlFor="cidade" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Cidade
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

          </div>

          <div class="col-12 mb-3">
            <span class="p-float-label">
              <input formControlName="streetAddress" pInputText id="logradouro" />
              <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Logradouro
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>
          </div>

          <div class="col-6 mb-5">
            <span class="p-float-label">
              <p-inputNumber inputId="integeronly" id="numero" formControlName="number">
              </p-inputNumber>
              <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Número
                <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
              </label>
            </span>

          </div>

          <div class="col-6 mb-5">
            <span class="p-float-label">
              <input formControlName="address2" pInputText id="complemento" />
              <label htmlFor="complemento" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                Complemento
              </label>
            </span>
          </div>
        </div>
      </ng-container>
    </form>
  </split-step>

  <split-step [passo]="2">
    <ng-container *ngIf="
      form.value.flagIssuesInvoice && !form.value.flagUsesHeadOfficeTaxData
    ">
      <form [formGroup]="form" class="mb-6">
        <ng-container formGroupName="representative">
          <div class="grid p-fluid mt-2">
            <div class="col-6 mb-3">
              <span class="p-float-label">
                <input (keydown)="validateChar($event)" pInputText id="nomeCompleto" formControlName="name" />
                <label htmlFor="nomeCompleto" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Nome Completo
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <!-- <div class="col-3 mb-3">
              <span class="p-float-label">
                <p-dropdown [filter]="true" filterBy="name" [options]="(ProfessionList$ | async)!"
                  [autoDisplayFirst]="false" optionLabel="name" inputId="float-label" formControlName="profession"
                  optionValue="@id">
                </p-dropdown>
                <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Profissão
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div> -->

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <p-inputNumber formControlName="monthlyIncome" id="valor" mode="currency" currency="BRL" locale="pt-BR"
                  currencyDisplay="symbol"> </p-inputNumber>
                <label htmlFor="valor" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Renda Mensal
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <p-inputMask [unmask]="true" [autoClear]="true" id="cpf" mask="999.999.999-99" formControlName="taxId">
                </p-inputMask>
                <label htmlFor="cpf" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  CPF
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <p-inputMask [unmask]="true" id="dataNascimento" mask="99/99/9999" formControlName="birthdate">
                </p-inputMask>
                <label htmlFor="dataNascimento" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Data de Nascimento
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <input pInputText id="email" formControlName="representativeEmail" />
                <label htmlFor="email" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Email
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <div class="col-6 mb-3">
              <span class="p-float-label">
                <p-inputMask [unmask]="true" [autoClear]="false" id="celular" mask="(99) 99999-9999"
                  formControlName="contactNumber">
                </p-inputMask>
                <label htmlFor="celular" class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                  Celular
                  <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                </label>
              </span>
            </div>

            <ng-container formGroupName="address">
              <div class="col-4 mb-3">
                <span class="p-float-label">
                  <p-inputMask #cep [unmask]="true" id="cep" formControlName="postalCode" mask="99999-999"
                    (onComplete)="autoCompleteAddress(cep.value!, 'representative')">
                  </p-inputMask>
                  <label htmlFor="cep" class="text-xs pl-1 h-1rem flex align-items-center">
                    CEP
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <div class="col-4 mb-3">
                <span class="p-float-label">
                  <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'"
                    (onChange)="loadCitiesByUF($event.value)" [filter]="true" filterBy="name" [options]="stateList"
                    optionLabel="name" optionValue="uf" id="estado" formControlName="state"></p-dropdown>

                  <label class="text-xs pl-1 h-1rem flex align-items-center" for="float-label">
                    Estado <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                      alt="alerta-campo-vazio" />
                  </label>
                </span>
              </div>

              <div class="col-4 mb-3">
                <span class="p-float-label">

                  <div class="flex justify-content-center align-items-center w-full h-3rem text-sm text-color-secondary"
                    *ngIf="isLoadingCities">
                    Aguarde...

                  </div>

                  <span class="p-float-label" *ngIf="!isLoadingCities">
                    <p-dropdown [emptyFilterMessage]="'Nenhum resultado encontrado'" [filter]="true" filterBy="nome"
                      [options]="citiesListPF" id="cidade" formControlName="city" optionLabel="nome" optionValue="id"
                      inputId="float-label"></p-dropdown>
                    <label for="float-label" class="text-xs pl-1 h-1rem flex align-items-center">
                      Cidade <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                        alt="alerta-campo-vazio" />
                    </label>
                  </span>
                </span>
              </div>

              <div class="col-8 mb-3">
                <span class="p-float-label">
                  <input pInputText id="logradouro" formControlName="streetAddress" />
                  <label htmlFor="logradouro" class="text-xs pl-1 h-1rem flex align-items-center">Logradouro
                    <img class="pl-1" src="assets\cadastrar-unidade\alerta-campo-vazio.svg"
                      alt="alerta-campo-vazio" /></label>
                </span>
              </div>
              <div class="col-4 mb-3">
                <span class="p-float-label">
                  <input pInputText id="bairro" formControlName="district" />
                  <label htmlFor="bairro" class="text-xs pl-1 h-1rem flex align-items-center">Bairro <img class="pl-1"
                      src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>
                </span>
              </div>

              <div class="col-4 mb-4">
                <span class="p-float-label">
                  <input pInputText id="numero" formControlName="number" />
                  <label htmlFor="numero" class="text-xs pl-1 h-1rem flex align-items-center">Número <img class="pl-1"
                      src="assets\cadastrar-unidade\alerta-campo-vazio.svg" alt="alerta-campo-vazio" /></label>

                </span>
              </div>

              <div class="col-8 mb-4">
                <span class="p-float-label">
                  <input pInputText id="complemento" formControlName="address2" />
                  <label htmlFor="complemento" class="text-xs pl-2">Complemento
                  </label>
                </span>
              </div>

            </ng-container>

          </div>
        </ng-container>
        <span class="confirmCheckbox">
          <p-checkbox class="mr-2" [binary]="true" inputId="binary"
            formControlName="selfDeclaredLegalRepresentative"></p-checkbox>
          Garanto que esse cadastro de pessoal física se identifica como representante legal do CNPJ do recebedor ao
          qual está atrelado.
        </span>
      </form>
    </ng-container>


  </split-step>

  <!-- upload certificate -->
  <split-step [passo]="3" *ngIf="form.value.flagIssuesInvoice">
    <form [formGroup]="uploadCertificateForm">
      <p-messages severity="warn" *ngIf="form.value.taxInfo?.digitalCertificationFile?.length">
        <ng-template pTemplate>
          <div class="border-none pl-0">Já existe um certificado carregado para esse CNPJ. <a
              [href]="form.value.taxInfo?.digitalCertificationFile" target="_blank" [style.color]="'#1A88CB'"> Clique
              aqui </a> para baixá-lo. </div>
        </ng-template>
      </p-messages>

      <p-messages severity="warn" *ngIf="!uploadCertificateForm.value.partnerId?.length">
        <ng-template pTemplate>
          <div class="border-none pl-0">
            Não foi possível carregar os dados fiscais, verifique os dados ou tente novamente mais tarde.
          </div>
        </ng-template>
      </p-messages>

      <div class="grid p-fluid"
        [ngClass]="{ 'mt-5' : form.value.taxInfo?.digitalCertificationFile?.length || !uploadCertificateForm.value.partnerId?.length}">
        <div class="col-12" [ngClass]=" { 'inativo' : !uploadCertificateForm.value.partnerId?.length }">
          <span class="p-float-label mb-3">
            <p-password formControlName="password" [feedback]="false" [toggleMask]="true">
            </p-password>
            <label for="password">Senha</label>
          </span>
        </div>

        <div class="col-12" [ngClass]=" { 'inativo' : !uploadCertificateForm.value.partnerId?.length }">
          <p-fileUpload [customUpload]="true" chooseLabel="CARREGAR ARQUIVO" [showUploadButton]="false"
            [showCancelButton]="false" class="mb-3" (onSelect)="setFile($event)" (onRemove)="setFile($event, true)"
            [multiple]="false" accept=".pfx" chooseIcon="pi pi-cloud-upload">
            <ng-template pTemplate="content">
              <div class="flex justify-content-center text-base" id="dragdropMessage">
                {{ dragdropMessage }}
              </div>
            </ng-template>
          </p-fileUpload>
        </div>

        <div class="col-12" [ngClass]=" { 'inativo' : !uploadCertificateForm.value.partnerId?.length }">
          <div class="flex justify-content-center mb-5">
            <p-button [disabled]="this.uploadCertificateForm.invalid || !certificateFile" label="Enviar Certificado"
              (click)="OnUpload()" severity="primary"></p-button>

          </div>
        </div>
      </div>

    </form>
  </split-step>

  <ng-template #customNextButton *ngIf="steps.activeIndex == 0 && !form.value.flagIssuesInvoice">
    <button class="s-step__button-next" [disabled]="firstStepValidation"
      [ngClass]="firstStepValidation ? 'inativo' : '' " (click)="steps.nextStep()">
      Próximo <i class="pi pi-arrow-right ml-3"></i>
    </button>

  </ng-template>

  <ng-template #customNextButton
    *ngIf="steps.activeIndex == 0 && form.value.flagIssuesInvoice && !form.value.flagUsesHeadOfficeTaxData">
    <button class="s-step__button-next" [disabled]="firstStepValidation"
      [ngClass]="firstStepValidation ? 'inativo' : '' " (click)="steps.nextStep()">
      Próximo <i class="pi pi-arrow-right ml-3"></i>
    </button>

  </ng-template>

  <ng-template #customNextButton *ngIf="
      steps.activeIndex == 0 &&
      form.value.flagIssuesInvoice &&
      !form.value.main &&
      form.value.flagUsesHeadOfficeTaxData
    ">
    <button [ngStyle]="{ height: '33.9px' }" type="submit" [disabled]="firstStepValidation"
      [ngClass]="firstStepValidation? 'inativo' : ''" (click)="OnSubmit()" class="flex ml-auto border-none bg-white"
      split-botao [botao]="{
    titulo: 'Finalizar',
    rota: '/cadastro/unidades',
    rightIcon: 'pi-check',
    estilo: 'laranja',
    }"></button>
  </ng-template>

  <ng-template #customNextButton *ngIf="steps.activeIndex == 1 && !form.value.flagIssuesInvoice">
    <!-- <button class="s-step__button-next" (click)="steps.nextStep()">Salvar</button> -->

    <button [ngStyle]="{ height: '33.9px' }" type="submit" [disabled]="secondStepValidation"
      [ngClass]="secondStepValidation? 'inativo' : ''" (click)="OnSubmit()" class="flex ml-auto border-none bg-white"
      split-botao [botao]="{
    titulo: 'finalizar',
    rota: '/cadastro/unidades',
    rightIcon: 'pi-check',
    estilo: 'laranja',


  }"></button>
  </ng-template>

  <ng-template #customNextButton *ngIf="steps.activeIndex == 1 && form.value.flagIssuesInvoice">
    <button class="s-step__button-next" [disabled]="secondStepValidation"
      [ngClass]="secondStepValidation ? 'inativo' : '' " (click)="steps.nextStep()">
      Próximo <i class="pi pi-arrow-right ml-3"></i>
    </button>

  </ng-template>


  <ng-template #customNextButton *ngIf="
      steps.activeIndex == 2 && form.value.flagIssuesInvoice
    ">

    <button [ngStyle]="{ height: '33.9px' }" type="submit" [disabled]="tirdStepValidation"
      [ngClass]="tirdStepValidation? 'inativo' : ''" (click)="OnSubmit()" class="flex ml-auto border-none bg-white"
      split-botao [botao]="{
    titulo: 'Salvar',
    rota: '/cadastro/unidades',
    rightIcon: 'pi-check',
    estilo: 'laranja',
    }"></button>
  </ng-template>

  <ng-template #customNextButton *ngIf="
      steps.activeIndex == 3 && form.value.flagIssuesInvoice 
    ">
    <button [ngStyle]="{ height: '33.9px' }" type="submit" (click)="closeModal()"
      class="flex ml-auto border-none bg-white" split-botao [botao]="{
            titulo: 'finalizar',
            rota: '/cadastro/unidades',
            rightIcon: 'pi-check',
            estilo: 'laranja',
        }"></button>
  </ng-template>


  <!-- <ng-template
    #customNextButton
    *ngIf="
      steps.activeIndex == 2 &&
      form.value.flagIssuesInvoice &&
      !form.value.main &&
      !form.value.flagUsesHeadOfficeTaxData
    "
  >
    <!-- <button class="s-step__button-next" (click)="steps.nextStep()">Salvar</button> -->

  <!--  <button
      [ngStyle]="{ height: '33.9px' }"
      type="submit"
      [disabled]="!form.valid"
      [ngClass]="!form.valid ? 'inativo' : ''"
      (click)="OnSubmit()"
      class="flex ml-auto border-none bg-white"
      split-botao
      [botao]="{
    titulo: 'Finalizar',
    rota: '/cadastro/unidades',
    rightIcon: 'pi-check',
    estilo: 'laranja',
    }"
    ></button>
  </ng-template> -->


  <!-- <split-step [passo]="1" *ngIf="form.value.flagIssuesInvoice && !form.value.main">
        <form [formGroup]="uploadCertificateForm">

            <div class="grid p-fluid">
                <div class="col-12">
                    <span class="p-float-label mb-3">
                        <p-password formControlName="password" [feedback]="false" [toggleMask]="true"> </p-password>
                        <label for="password">Password</label>
                    </span>
                </div>

                <div class="col-12">
                    <p-fileUpload [customUpload]="true" chooseLabel="CARREGAR ARQUIVO" [showUploadButton]="false"
                        [showCancelButton]="false" class="mb-5" (onSelect)="setFile($event)"
                        (onRemove)="setFile($event, true)" [multiple]="false" accept=".pfx" chooseIcon="pi pi-cloud-upload">
                        <ng-template pTemplate="content">
                            <div class="flex justify-content-center text-base" id="dragdropMessage">
                                {{dragdropMessage}}
                            </div>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </div>

        </form>
    </split-step>  -->
  <!--  end of upload certificate -->

  <!-- <ng-template #customNextButton *ngIf="steps.activeIndex == 0 && form.value.flagIssuesInvoice && !form.value.main">
    

        <button [ngStyle]="{'height': '33.9px'}" type="submit" [disabled]="!form.valid"
            [ngClass]="!form.valid ? 'inativo' : ''  " (click)="OnSubmit()" class="flex ml-auto border-none bg-white"
            split-botao [botao]="{
    titulo: 'Salvar',
    rota: '/cadastro/unidades',
    rightIcon: 'pi-check',
    estilo: 'laranja',
    }"></button>
    </ng-template> -->

  <!-- <ng-template #customNextButton
        *ngIf="steps.activeIndex == 0 && form.value.flagIssuesInvoice && form.value.flagUsesHeadOfficeTaxData && !form.value.main">
        <!-- <button class="s-step__button-next" (click)="steps.nextStep()">Salvar</button> -->

  <!---<button [ngStyle]="{'height': '33.9px'}" type="submit" [disabled]="!form.valid"
            [ngClass]="!form.valid ? 'inativo' : ''  " (click)="OnSubmit()" class="flex ml-auto border-none bg-white"
            split-botao [botao]="{
    titulo: 'finalizar',
    rota: '/cadastro/unidades',
    rightIcon: 'pi-check',
    estilo: 'laranja',


  }"></button>
    </ng-template> -->

  <!-- <ng-template #customNextButton *ngIf="steps.activeIndex == 1 && form.value.flagIssuesInvoice && !form.value.main">
        <button 
        [ngStyle]="{'height': '33.9px'}" 
        type="submit" 
        [disabled]="certificateFormValidation"
            [ngClass]="certificateFormValidation ? 'inativo' : ''  " (click)="OnUpload()" class="flex ml-auto border-none bg-white"
            split-botao [botao]="{
            titulo: 'finalizar',
            rota: '/cadastro/unidades',
            rightIcon: 'pi-check',
            estilo: 'laranja',
        }">
        </button>
    </ng-template>  -->
</split-steps>

<div *ngIf="isLoadingUnit == true || (unitState$ | async)?.type === 'loading' || isUploadLoading"
  class="flex align-items-center justify-content-center">
  <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>